import { FC } from 'react';
import * as stylex from '@stylexjs/stylex';
import { formatDate } from '@shared/libs/format-date';
import { styles } from '../../styles';
import { InfoFilledIcon } from '@shared/assets/icons';

interface ConfirmationAlertProps {
  sendTicketAfterAcceptAt?: string | null;
  onCancel: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

export const ConfirmationAlert: FC<ConfirmationAlertProps> = ({
  sendTicketAfterAcceptAt,
  onCancel,
  onConfirm,
  isLoading,
}) => {
  return (
    <div {...stylex.props(styles.confirmationAlert)}>
      <InfoFilledIcon />
      <div {...stylex.props(styles.confirmationAlertContent)}>
        <div {...stylex.props(styles.confirmationAlertText)}>
          {sendTicketAfterAcceptAt
            ? `Билет будет отправлен ${formatDate(sendTicketAfterAcceptAt)}`
            : 'Билет будет отправлен сразу'}
        </div>
        <div {...stylex.props(styles.confirmationAlertButtons)}>
          <button
            {...stylex.props(styles.customButton)}
            onClick={(e) => {
              e.stopPropagation();
              onCancel();
            }}
            disabled={isLoading}
          >
            Отмена
          </button>
          <button
            {...stylex.props(styles.customButton)}
            onClick={(e) => {
              e.stopPropagation();
              onConfirm();
            }}
            disabled={isLoading}
          >
            Подтвердить
          </button>
        </div>
      </div>
    </div>
  );
};
